import { useTranslation } from "react-i18next";

export function formatDate(dateString?: string | null) {
  if (!dateString) return "-";
  const d = new Date(dateString);
  return d.toLocaleDateString("en-GB");
}

export function timeAgo(dateString?: string | null) {
  const { t } = useTranslation();
  if (!dateString) return "-";
  const d = new Date(dateString).getTime();
  const now = Date.now();
  const diffSec = Math.floor((now - d) / 1000);

  if (diffSec < 60)
    return `${diffSec} ${t("T_SITE_SECONDS")} ${t("T_SITE_PROFILE_STATISTICS_AGO_SUFFIX")}`;
  if (diffSec < 3600)
    return `${Math.floor(diffSec / 60)} ${t("T_SITE_MINUTES")} ${t("T_SITE_PROFILE_STATISTICS_AGO_SUFFIX")}`;
  if (diffSec < 86400)
    return `${Math.floor(diffSec / 3600)} ${t("T_SITE_HOURS")} ${t("T_SITE_PROFILE_STATISTICS_AGO_SUFFIX")}`;
  return `${Math.floor(diffSec / 86400)} ${t("T_SITE_DAYS")} ${t("T_SITE_PROFILE_STATISTICS_AGO_SUFFIX")}`;
}

function getTimeLeft(isoString: string) {
  const future = new Date(isoString).getTime();
  const now = Date.now();
  const diff = future - now;

  if (diff <= 0) return "00:00:00";

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function getDaysUntilExpiry(dateString?: string | null): number | null {
  if (!dateString) return null;
  const expiryDate = new Date(dateString).getTime();
  if (isNaN(expiryDate)) return null;
  const now = Date.now();
  const diffMs = expiryDate - now;
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function formatTimeParts(ms: number) {
  const totalSeconds = Math.floor(ms / 1000);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    d: days.toString(),
    h: hours.toString().padStart(2, "0"),
    m: minutes.toString().padStart(2, "0"),
    s: seconds.toString().padStart(2, "0"),
  };
}
